<div class="modal-header">
  <div class="grow-1 d-flex">
    <h1 class="modal-title h1 mt-0 pr-4">{{ title }}</h1>
  </div>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span class="inner-close" aria-hidden="true">X</span>
  </button>
</div>
<div class="modal-body">
  <p class="modal-text" *ngIf="description" [innerHTML]="description"></p>
  <div class="wrapper-button mt-20">
    <button
      class="btn btn-default btn-cancel btn-180 w-md-100"
      type="button"
      (click)="closeModal()"
    >
      CANCEL
    </button>
    <button
      class="btn btn-default btn-dark-blue btn-right btn-180 w-sm-100 btn-order-first"
      [disabled]="loading$ | async"
      (click)="confirm()"
      type="submit"
    >
      {{ actionLabel }}
    </button>
  </div>
</div>
